var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whitespace-nowrap font-bold text-dark"},[_c('span',{staticClass:"hidden lg:inline"},[_vm._v(_vm._s(_vm.resultStart)+" - "+_vm._s(_vm.resultEnd)+" of ")]),_vm._v(_vm._s(_vm.resultCount)),(_vm.resultCount >= 1000)?[_vm._v("+")]:_vm._e(),_vm._v(" "+_vm._s(_vm.resultLabel))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }